export const en = {
	flag: '🇬🇧',
	name: 'English',
	code: 'en',
	nav: {
		services: 'Services',
		realizations: 'Work',
		about: 'About',
		cta: 'Start a project',
		contact: 'Contact',
		skip: 'Skip to main content',
		mainLabel: 'Main navigation',
		homeLabel: 'Kuba Studio, home',
		langShort: 'FR',
		langSwitchLabel: 'Passer en français',
		themeToDark: 'Switch to dark theme',
		themeToLight: 'Switch to light theme',
		openMenu: 'Open menu',
		closeMenu: 'Close menu',
	},
	hero: {
		badge: 'Digital Studio · Île-de-France',
		tagline:
			'Studio specialized in web & mobile applications, software solutions and SaaS platforms.',
		ctaRealizations: 'See our work',
		ctaContact: 'Start a project',
		stat1Value: 'Web & Mobile',
		stat1Label: 'Applications',
		stat2Value: 'SaaS & Software',
		stat2Label: 'Solutions',
		stat3Value: '2025',
		stat3Label: 'Founded',
		h1Line1: 'From idea',
		h1Pre: 'to',
		h1Accent: 'finished product,',
		h1Line3: 'together.',
		floatMobileTitle: 'Web, iOS & Android',
		floatMobileSub: 'Coasso, in beta',
		floatProdTitle: 'In production',
		floatProdSub: 'real products',
		techLabel: 'Technologies we use',
		scrollText: 'Explore',
	},
	services: {
		eyebrow: 'Expertise',
		title: 'What we build',
		subtitle: 'From concept to production, we cover the full spectrum of digital development.',
		learnMore: 'Learn more',
		webTitle: 'Web Applications',
		webDesc: 'Modern interfaces and high-performance digital platforms built to last.',
		webF1: 'Next.js & React',
		webF2: 'Single Page Applications',
		webF3: 'Dashboards & back-offices',
		webF4: 'SEO & performance',
		mobileTitle: 'Mobile Applications',
		mobileDesc: 'Native and cross-platform iOS and Android apps, from wireframe to store.',
		mobileF1: 'React Native & Flutter',
		mobileF2: 'iOS & Android',
		mobileF3: 'UI/UX design',
		mobileF4: 'App Store deployment',
		softwareTitle: 'Software Solutions',
		softwareDesc: 'Custom software, APIs and integrations tailored to your business processes.',
		softwareF1: 'REST & GraphQL APIs',
		softwareF2: 'Desktop software',
		softwareF3: 'Automations',
		softwareF4: 'Third-party integrations',
		saasTitle: 'SaaS Platforms',
		saasDesc: 'Scalable, multi-tenant cloud architecture ready for growth.',
		saasF1: 'Cloud architecture',
		saasF2: 'Multi-tenant',
		saasF3: 'Scalability & monitoring',
		saasF4: 'Billing & subscriptions',
	},
	realizations: {
		eyebrow: 'Our work',
		title: 'What we have built',
		subtitle: 'Internal and client projects — real products, in production, used every day.',
		loading: 'Loading…',
		visitSite: 'Visit site',
		coasso: {
			name: 'Coasso — for members',
			alt: 'Coasso home page',
			tag: 'Beta · Web, iOS & Android',
			description:
				'The members app: find an association near you, sign up, pay your membership online and follow your activities, with a map of clubs to discover what is available around you.',
			stack: ['Flutter', 'Go', 'PostgreSQL', 'Stripe'],
		},
		coassopro: {
			name: 'Coasso Pro — for associations',
			alt: 'Coasso Pro home page',
			tag: 'Beta · SaaS',
			description:
				'The management tool for leaders of sports, cultural and community associations: members and registrations, online payments collected directly by the association, scheduling, forms, messaging and roles. Free during the beta, GDPR-compliant, data hosted in Europe.',
			stack: ['Flutter', 'Go', 'Cloud Run', 'Stripe Connect'],
		},
		patrol: {
			name: 'Patrol',
			alt: 'Patrol website home page',
			tag: 'Web application',
			description:
				'Website built for Patrol, a company specialising in private security and field surveillance.',
			stack: ['Next.js', 'Firebase', 'TypeScript', 'Tailwind CSS'],
		},
		novaccord: {
			name: 'Novaccord',
			alt: 'Novaccord website home page',
			tag: 'Showcase website',
			description:
				'Corporate website for a mediation company, designed to present Novaccord support in preventing and resolving conflicts between professionals.',
			stack: ['Next.js', 'TypeScript', 'Tailwind CSS'],
		},
		picstat: {
			name: 'Picstat',
			alt: 'Picstat home page',
			tag: 'Mobile app',
			description:
				'Photo and video editing app with overlays generated from your Strava activities — GPX routes, stats and training data superimposed on your content.',
			stack: ['React Native', 'Expo', 'TypeScript', 'Firebase'],
		},
		tivea: {
			name: 'Tivea',
			alt: 'VAT return screen in Tivea',
			tag: 'Mac & iOS app',
			description:
				'Mac, iPad and iPhone app for business financial management: purchases, income, bank accounts and VAT returns, with encrypted data that stays with you.',
			stack: ['Swift', 'SwiftUI', 'CryptoKit', 'iCloud'],
		},
		discoverApp: 'Discover the app',
		newTab: '(opens in a new tab)',
		screenshotAlt: 'app screenshot',
	},
	about: {
		eyebrow: 'About',
		title: 'Kuba Studio',
		subtitle: 'A studio built on technical rigor and product ambition.',
		statementPre: 'A studio built on technical rigor and ',
		statementAccent: 'product ambition.',
		headline: 'From idea to finished product, together.',
		para1:
			'Kuba Studio is a development studio specialized in designing and launching web & mobile applications, software solutions and SaaS platforms.',
		para2:
			'We build quality products — both our own tools and custom solutions for our clients — with the same standards of excellence.',
		para3:
			'Our approach: clean code, solid architecture and constant attention to user experience.',
		missionTitle: 'Our mission',
		missionDesc: 'Make technology accessible and build products that have a real impact.',
		velocityTitle: 'Our approach',
		velocityDesc: 'Fast shipping, short iterations, non-negotiable quality.',
		qualityTitle: 'Our standards',
		qualityDesc: 'Clean code, solid architecture, documentation and tests at every step.',
		stat1Value: '5',
		stat1Label: 'Projects delivered',
		stat2Value: 'Web · Mobile · SaaS · Software',
		stat2Label: 'Expertise',
		stat3Value: '2025',
		stat3Label: 'Founded',
	},
	contact: {
		eyebrow: 'Contact',
		title: "Let's talk about your project",
		subtitle: 'Got an idea? A project underway? Write to us, we respond quickly.',
		formTitle: "Let's turn your ideas into reality",
		formDesc:
			'Whether you have a specific project or just an idea, we are here to accompany you from design to launch.',
		emailLabel: 'Email',
		locationLabel: 'Location',
		locationValue: 'Île-de-France',
		nameLabel: 'Name',
		emailPlaceholder: 'your@email.com',
		companyPlaceholder: 'Company (optional)',
		messageLabel: 'Message',
		messagePlaceholder: 'Describe your project…',
		nameError: 'Name must be at least 3 characters.',
		emailError: 'Invalid email address.',
		messageError: 'Message must be at least 10 characters.',
		sendButton: 'Send message',
		sendingButton: 'Sending…',
		successMessage: 'Message sent! We will get back to you very soon.',
		sendAnother: 'Send another message',
		errorMessage: 'An error occurred. Please try again.',
	},
	footer: {
		tagline: 'Studio specialized in web & mobile applications, software solutions and SaaS platforms.',
		navLabel: 'Navigation',
		services: 'Services',
		realizations: 'Work',
		about: 'About',
		contact: 'Contact',
		projectsLabel: 'Projects',
		legal: 'Legal Notice',
		followLabel: 'Follow',
		location: 'Île-de-France',
		linkedin: 'LinkedIn',
		linkedinAria: 'Kuba Studio on LinkedIn (opens in a new tab)',
		emailAria: 'Email contact@kuba-studio.com',
		newTab: '(opens in a new tab)',
		homeAria: 'Kuba Studio, top of page',
		copyright: 'All rights reserved.',
	},
	legalPage: {
		title: 'Legal Notice',
		lastUpdate: 'Last update',
		publisherTitle: 'Site Publisher',
		companyName: 'Company name',
		companyNameValue: 'Kuba Studio',
		legalStatus: 'Legal form',
		legalStatusValue: 'SASU',
		headquarters: 'Headquarters',
		headquartersValue: '57 bis rue du chêne, 77380 Combs-la-Ville, France',
		siren: 'SIREN',
		sirenValue: '993 476 357',
		vat: 'Intra-community VAT number',
		vatValue: 'FR02993476357',
		capital: 'Share capital',
		capitalValue: '2,000 EUR',
		contact: 'Contact',
		contactValue: 'contact@kuba-studio.com',
		hostingTitle: 'Hosting',
		hostingName: 'Name',
		hostingNameValue: 'Google Cloud Platform',
		hostingCompany: 'Company',
		hostingCompanyValue: 'Google LLC',
		hostingAddress: 'Address',
		hostingAddressValue: '1600 Amphitheatre Parkway, Mountain View, CA 94043, United States',
		ipTitle: 'Intellectual Property',
		ipContent:
			'The entire site (design, logos, texts, images, source code) is the exclusive property of Kuba Studio and is protected by copyright. Any reproduction or use without authorization is prohibited.',
	},
	privacyTivea: {
		title: 'Privacy Policy — Tivea',
		lastUpdate: 'Last updated',
		summaryTitle: 'In short',
		summary:
			'Tivea collects no data. The app runs entirely on your device: no information is sent to Kuba Studio or to any third party.',
		scope:
			'This policy describes how data is handled in the Tivea app for macOS and iOS, published by Kuba Studio.',
		noCollectionTitle: 'No data collection',
		noCollectionIntro:
			'We do not collect, store or transmit any personal data. Specifically:',
		noCollectionItems: [
			'No account, no sign-up, no identifier required.',
			'No usage statistics, no analytics tools, no trackers.',
			'No advertising and no advertising SDK.',
			'No third-party SDK capable of collecting data.',
			'No server: the app does not communicate with any Kuba Studio service.',
		],
		storageTitle: 'Where your data lives',
		storageIntro:
			'All the data you enter (purchases, income, bank accounts, transfers, VAT returns) is stored in a .tivea file whose location you choose:',
		storageItems: [
			'on your device: local disk, or any network volume / NAS of your choice;',
			'or in your own iCloud, if you enable that option.',
		],
		storageNote:
			'With iCloud, syncing is handled by Apple between your own devices, under your Apple Account. Kuba Studio has no access to it.',
		encryptionTitle: 'Encryption',
		encryptionIntro:
			'The contents of your files are encrypted with AES-GCM 256-bit. The encryption key is, depending on your choice:',
		encryptionItems: [
			'derived from a password only you know (PBKDF2-HMAC-SHA256);',
			'or randomly generated and stored in your device Keychain.',
		],
		encryptionNote:
			'Your password is never transmitted nor stored: we cannot recover your data if you lose it.',
		rightsTitle: 'Your rights (GDPR)',
		rightsContent:
			'As we hold no data about you, there is nothing for us to access, correct, export or delete. You keep full control of your files: you can copy, move or delete them directly from your device.',
		childrenTitle: 'Children',
		childrenContent:
			'Tivea is a professional financial management tool and is not directed at children. As no data is collected, no children’s data can be collected.',
		changesTitle: 'Changes',
		changesContent:
			'Any change to this policy will be published on this page, with an updated revision date.',
		contactTitle: 'Contact',
		contactContent: 'For any question regarding this policy:',
		contactEmail: 'contact@kuba-studio.com',
	},
	supportTivea: {
		title: 'Support — Tivea',
		intro:
			'Need help with Tivea? Write to us and we will reply within 2 business days. Here are the most common questions.',
		contactTitle: 'Contact us',
		contactContent: 'A question, a bug, a suggestion:',
		contactEmail: 'contact@kuba-studio.com',
		faqTitle: 'Frequently asked questions',
		faq: [
			{
				q: 'Where is my data stored?',
				a: 'In a .tivea file whose location you choose: on your Mac or iPhone, on a network volume / NAS, or in your iCloud. Everything is encrypted with AES-256. We never have access to it.',
			},
			{
				q: 'I lost my password, what can I do?',
				a: 'The password is never transmitted nor stored: a protected vault whose password is lost cannot be recovered. That is the price of genuinely secure encryption. Keep it in a password manager.',
			},
			{
				q: 'How do I sync between my Mac and my iPhone?',
				a: 'When creating the vault, choose the “iCloud” location. The file then syncs automatically between your devices signed in to the same Apple Account. Make sure iCloud Drive is enabled.',
			},
			{
				q: 'How do I import my bank statement?',
				a: 'Accounts section → “Import a statement”. Tivea reads CSV and OFX files. For a CSV you pick the columns (date, label, amount) and a preview appears: negative amounts become purchases, positive ones become income.',
			},
			{
				q: 'How is VAT calculated?',
				a: 'Standard scheme (monthly CA3): VAT collected on your income minus deductible VAT on your purchases. If the month yields a credit, you choose to carry it forward to the next month or to request a refund.',
			},
			{
				q: 'Does Tivea replace an accountant?',
				a: 'No. Tivea helps you track your operations and prepare your returns, but the amounts remain indicative and under your responsibility. Report them on your official return and have your accounts validated by a professional.',
			},
		],
		requirementsTitle: 'Requirements',
		requirementsContent: 'macOS 14.4 or later — iOS 17.4 or later, iPad included. One-time purchase, valid on Mac, iPad and iPhone.',
	},
	tiveaPage: {
		badge: 'Mac · iPad · iPhone app',
		tagline: 'Your finances and VAT, without the headache.',
		intro:
			'Track your purchases, income and bank accounts, and prepare your VAT returns in minutes. Your data is encrypted and stays with you.',
		appStoreSmall: 'Download on the',
		appStoreBig: 'App Store',
		supportLink: 'Help & support',
		meta: 'One-time purchase · macOS 14.4+ · iOS 17.4+',
		heroChips: ['AES-256 encrypted', 'VAT calculated', 'iCloud sync'],
		iconAlt: 'Tivea app icon',
		galleryAria: 'Tivea screenshots',
		galleryEyebrow: 'Preview',
		galleryTitle: 'The app at a glance',
		gallerySubtitle: 'A clear, native interface built for speed.',
		gallery: ['Dashboard', 'VAT return', 'Reports', 'Bank accounts', 'Recurring'],
		featuresEyebrow: 'Features',
		featuresTitle: 'All your tracking, in one place',
		featuresSubtitle: 'Built for business owners and freelancers who want clarity, without complex accounting software.',
		features: [
			{
				title: 'Automatic VAT calculation',
				desc: 'VAT collected minus deductible VAT, monthly (CA3) or yearly (CA12), with VAT credit carried forward to the next period.',
			},
			{
				title: 'Accounts & bank statements',
				desc: 'Import your CSV or OFX statements: expenses become purchases, receipts become income. Duplicates are detected.',
			},
			{
				title: 'Invoices & clients',
				desc: 'Issue invoices, track your clients and payments, and attach receipts to every transaction.',
			},
			{
				title: 'Reports & exports',
				desc: 'Dashboard, reports, PDF export and files ready to hand over to your accountant.',
			},
			{
				title: 'End-to-end encrypted',
				desc: 'Every .tivea file is encrypted with AES-GCM 256-bit, protected by a password or your device Keychain.',
			},
			{
				title: 'Mac, iPad and iPhone',
				desc: 'A native SwiftUI app, synced through your iCloud. One purchase for all your devices.',
			},
		],
		privacyEyebrow: 'Privacy',
		privacyTitle: 'Your numbers are nobody else’s business',
		privacyDesc:
			'Tivea runs entirely on your device. No account, no server, no trackers: Kuba Studio never has access to your data.',
		privacyPoints: [
			'No data collected, no usage statistics.',
			'Files stored wherever you want: Mac, NAS or iCloud.',
			'AES-256 encryption, password never transmitted.',
			'No advertising, no third-party SDK.',
		],
		privacyLink: 'Read the privacy policy',
		ctaTitle: 'Ready to take back control of your accounts?',
		ctaDesc: 'Download Tivea on your Mac, iPad or iPhone and prepare your next VAT return with peace of mind.',
		privacyPolicyLink: 'Privacy policy',
		disclaimer:
			'Tivea helps you track your operations and prepare your returns; amounts remain indicative and do not replace the advice of an accountant.',
	},
};
